

























import Vue, { PropType } from 'vue';
import SearchBannerFormItem from '../SearchBannerFormItem.vue';
import type { DrawerConfig, AmountOption } from '../types';

type Option = AmountOption;

export default Vue.extend({
  name: 'SearchBannerAmountDropdown',
  components: {
    SearchBannerFormItem,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    drawerConfig: {
      type: Object as PropType<DrawerConfig>,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue(): string | undefined {
      if (this.isDesktop) {
        return this.$store.getters[`${this.storeNamespace}/amountDisplayValueDesktop`];
      }
      return this.$store.getters[`${this.storeNamespace}/amountDisplayValueMobile`];
    },
    options(): Option[] {
      return this.$store.getters[`${this.storeNamespace}/amountOptions`] || [];
    },
    value(): number | undefined {
      return this.$store.getters[`${this.storeNamespace}/amountData`];
    },
    isActive: {
      get(): boolean {
        return this.active;
      },
      set(value: boolean) {
        this.$emit('update:active', value);
      },
    },
  },
  methods: {
    async handleSelect(value: number) {
      await this.$store.dispatch(`${this.storeNamespace}/updateAmount`, value);
      this.$emit('amount-selected');
      this.isActive = false;
    },
  },
});
